import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { Info } from '../../../shared/interface';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-info-backoffice',
  templateUrl: './info-backoffice.component.html',
  styleUrl: './info-backoffice.component.css'
})
export class InfoBackofficeComponent {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService) {}

  @ViewChild("deleteInfo") deleteInfo!: ConfirmPopup;

  infos: Info[] = [];  

  loading: boolean = false;

  ngOnInit(): void {
    
    this.loading = true;

    this.apiService.setInfos();
    this.apiService.infosChanged.subscribe({
      next: (data) => {
        this.infos = [...data];
        this.loading = false;
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),      
    })
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDeleteInfo(event: Event, info: Info) {        
    this.confirmationService.confirm({      
      target: event.target as EventTarget,
      message: `Sei sicuro di voler eliminare la info?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteInfo(info.id).subscribe({          
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {  
            this.confirmationService.close()
            this.apiService.setInfos()
            this.apiService.message("success", "Eliminazione", "La info è stata eliminata con successo")
          }
        })
      }
    });
  }

  onDeleteInfo() {
    this.deleteInfo.accept();
  }

  onAnnullaDeleteInfo() {
    this.deleteInfo.reject();
  }

  onReorder(e: any) {

    this.infos.map((info, index) => info.posizione = index)

    this.apiService.updateInfos({infos: this.infos}).subscribe({
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {  
        this.apiService.setInfos()
        this.apiService.message("success", "Aggiornamento", "La posizione delle info è stata modificata con successo")
      }    
    })

  }

}
